import {
  ErrorPlatformEvent,
  Interpreter,
  createMachine,
  sendParent,
  StateNode,
} from 'xstate-v4'
import { rootContainer } from '~/container'
import sentryCapture from '~/utility/sentryCapture'

interface UserStoredCardSchema {
  states: {
    showing: {}
    removing: {}
    removed: {}
  }
}

interface UserStoredCardEvent {
  type: 'REMOVE'
  cardId: string
}

interface UserStoredCardContext {
  brand: string
  canDelete: boolean
  id: string
  last4: string
  expMonth: string
  expYear: string
}

export const userStoredCardMachine = createMachine<
  UserStoredCardContext,
  UserStoredCardSchema,
  UserStoredCardEvent
>(
  {
    context: {
      brand: '',
      canDelete: true,
      expMonth: '',
      expYear: '',
      id: '',
      last4: '',
    },
    initial: 'showing',
    states: {
      showing: {
        on: {
          REMOVE: { target: 'removing', cond: (ctx) => ctx.canDelete },
        },
      },
      removing: {
        invoke: {
          src: 'removeCard',
          onDone: 'removed',
          onError: {
            target: 'showing',
            actions: 'logError',
          },
        },
      },
      removed: {
        entry: sendParent<UserStoredCardContext, UserStoredCardEvent>(
          (ctx: UserStoredCardContext) => ({
            type: 'REMOVE',
            cardId: ctx.id,
          }),
        ),
        type: 'final',
      },
    },
  },
  {
    services: {
      removeCard: () => {
        throw new Error('userStoredCardMachine removeCard not implemented')
      },
    },
    actions: {
      logError: (_, _event: any) => {
        const event: ErrorPlatformEvent = _event
        event.data.name = `userStoredCardMachine ${event.type} error`
        sentryCapture(event.data, rootContainer)
      },
    },
  },
)

export type UserStoredCardMachineWithConfig = StateNode<
  UserStoredCardContext,
  UserStoredCardSchema,
  UserStoredCardEvent
>

export type UserStoredCardMachineInterpreter = Interpreter<
  UserStoredCardContext,
  UserStoredCardSchema,
  UserStoredCardEvent
>
